module.exports = "/img/bmw.5aae8b19.png";